import React from 'react';
import { Box } from '@mui/material';

const inventoryActions = [
  { icon: '🔴', color: 'red', title: '3 Critical stockouts', desc: 'Carmozyme 250mg, Carmozyme 500mg, Antibiotic Cap 500' },
  { icon: '🟡', color: 'amber', title: '5 At-risk items', desc: 'Monitor: Carmozyme Syrup, Analgesic Syrup, Antibiotic Cap 250, Antibiotic Syrup, Ayurvedic Tonic' },
  { icon: '📦', color: 'blue', title: '10 Pending orders', desc: 'In pipeline, expected delivery this month' },
  { icon: '⚡', color: 'teal', title: 'Fulfilment improved', desc: 'Avg time ▼ 0.6d to 3.4 days' },
];

export default function InventoryActionCenterCard() {
  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title">Action Center</h3>
      </div>
      <div className="alert-list" style={{ height: '220px', overflow: 'auto' }}>
        {inventoryActions.map((action, i) => (
          <Box key={i} className="alert-item">
            <Box
              className={`alert-icon ${action.color === 'red' ? 'crit' : 'warn'}`}
              style={{ background: `var(--${action.color}-bg)`, color: `var(--${action.color})` }}
            >
              {action.icon}
            </Box>
            <Box className="alert-text">
              <b>{action.title}</b>
              <div className="alert-time">{action.desc}</div>
            </Box>
          </Box>
        ))}
      </div>
    </Box>
  );
}
